import { useState } from 'react';
import RubricList from '../../components/admin/rubrics/RubricList';
import RubricForm from '../../components/admin/rubrics/RubricForm';
import RubricPreview from '../../components/admin/rubrics/RubricPreview';
import Modal from '../../components/shared/UI/Modal';
import Button from '../../components/shared/UI/Button';

export default function RubricsPage() {
  const [view, setView] = useState('list');
  const [selectedRubric, setSelectedRubric] = useState(null);
  const [isNewVersion, setIsNewVersion] = useState(false);
  const [previewRubric, setPreviewRubric] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  function handleSaved() {
    setView('list');
    setSelectedRubric(null);
    setIsNewVersion(false);
    setRefreshKey(k => k + 1);
  }

  function handleEdit(rubric, newVersion = false) {
    setSelectedRubric(rubric);
    setIsNewVersion(newVersion);
    setView('edit');
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Rubric Configuration</h1>
          <p>Configure scoring rubrics for PIF submissions. Published rubrics are locked.</p>
        </div>
      </div>

      {view === 'list' && (
        <RubricList
          key={refreshKey}
          onAdd={() => { setSelectedRubric(null); setIsNewVersion(false); setView('add'); }}
          onEdit={handleEdit}
          onPreview={setPreviewRubric}
        />
      )}

      {(view === 'add' || view === 'edit') && (
        <div>
          <div style={{ marginBottom: 20 }}>
            <Button variant="ghost" onClick={() => { setView('list'); setSelectedRubric(null); }}>
              ← Back to Rubrics
            </Button>
          </div>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 20 }}>
            {view === 'add' ? 'New Rubric' : isNewVersion ? `New Version of: ${selectedRubric?.name}` : `Edit: ${selectedRubric?.name}`}
          </h2>
          <RubricForm
            rubric={view === 'edit' ? selectedRubric : null}
            isNewVersion={isNewVersion}
            onSaved={handleSaved}
            onCancel={() => { setView('list'); setSelectedRubric(null); }}
            onPreview={setPreviewRubric}
          />
        </div>
      )}

      <Modal
        isOpen={!!previewRubric}
        onClose={() => setPreviewRubric(null)}
        title={`Preview: ${previewRubric?.name}`}
        size="lg"
      >
        <RubricPreview rubric={previewRubric} onClose={() => setPreviewRubric(null)} />
      </Modal>
    </div>
  );
}
